import { useTranslation } from 'react-i18next'

import { CustomIcon } from 'src/components/CoffeeMatch/CustomIcon/CustomIcon'
import { Text } from 'src/components/Text/Text'
import { COFFEE_MATCH_CHOICE } from 'src/selectors'

import styles from './Choice.module.scss'

interface ChoiceProps {
  value: string
  hasDescription?: boolean
  onChoiceSelected: (choice: string) => void
}

export const Choice = ({ value, hasDescription, onChoiceSelected }: ChoiceProps) => {
  const { t } = useTranslation()

  const choiceLabel = t(`coffeeMatch.choices.${value}`)
  const choiceDescription = t(`coffeeMatch.choiceDescriptions.${value}`)

  return (
    <button
      type="button"
      name={String(choiceLabel)}
      className={styles.wrapper}
      data-cy={COFFEE_MATCH_CHOICE}
      onClick={() => onChoiceSelected(value)}
    >
      <CustomIcon name={value} className={styles.icon} />

      <div>
        <Text variant="p" bold>
          {choiceLabel}
        </Text>

        {hasDescription && <Text small>{choiceDescription}</Text>}
      </div>
    </button>
  )
}
